export default {
  title: 'KYC reports',
  tableHeaderActionTooltip: 'Create new KYC report',
  dialog: {
    title: {
      generateReport: 'Generate KYC report',
      deleteReport: 'Delete KYC report',
      cancelReport: 'Cancel KYC report',
      regenerateReport: 'Regenerate KYC report',
      retryReport: 'Retry KYC report generation'
    }
  },
  tooltip: {
    generateReport: 'Generate KYC report',
    cancel: 'Cancel',
    delete: 'Delete',
    details: 'Details',
    download: 'Download',
    regenerate: 'Regenerate',
    retry: 'Retry'
  },
  reportName: {
    label: 'Name',
    placeholder: 'Enter KYC report name'
  },
  filtersForm: {
    startingDate: {
      label: 'Starting date',
      placeholder: 'YYYY-MM-DD hh:mm:ss'
    },
    endDate: {
      label: 'End date',
      placeholder: 'YYYY-MM-DD hh:mm:ss'
    },
    statuses: {
      label: 'Statuses',
      placeholder: 'Select statuses'
    },
    queryType: {
      label: 'Query Type',
      placeholder: 'Select operators'
    },
    operationIds: {
      label: 'Operation Ids',
      placeholder: 'Select operation Ids'
    }
  },
  details: {
    startingDate: {
      label: 'Starting date'
    },
    endDate: {
      label: 'End date'
    },
    statuses: {
      label: 'Status(es)'
    },
    queryType: {
      label: 'Query Type(s)',
      placeholder: 'Select operators'
    },
    operationIds: {
      label: 'Operation Id(s)'
    }
  },
  warningMsg:
    // eslint-disable-next-line max-len
    'You reached the max number of active/pending reports. To add a new one, or retry existing you need to delete the existing/pending ones.'
};
